module.exports = __webpack_public_path__ + "h5/img/logo7.df4149e0.png";